import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { createBlackList, updateBlackList } from "@api/procurements/vendor";
import {
  ErrorModal,
  InputDateControllerVertical,
  InputTextAreaVertical,
  MultiFileRow,
  SuccessModal,
} from "@components";
import { Button, InputSwitch, Modal, Text } from "@pentabd/ui";
import { convertMultipleDocumentData } from "@utils/documentDataConvert";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@constants/routes";

type BlackListModalProps = {
  openModal: boolean;
  closeModal: () => void;
  //   vendorOpeningId: number;
  historyId?: number | null | string | undefined;
  id: number | string;
};

export default function HistoryModal({
  openModal,
  closeModal,
  //   vendorOpeningId,
  historyId,
  id,
}: BlackListModalProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);

  const {
    control,
    register,
    setValue,
    handleSubmit,
    formState: { errors },
    reset,
  } = useFormContext();

  const onSubmit = async (data: any) => {
    try {
      const convertedData = convertMultipleDocumentData(data, [
        "historyDocuments",
      ]);
      let resData;
      if (historyId) {
        if (!data?.isBlackList) {
          resData = await createBlackList(id, convertedData);
        } else {
          resData = await updateBlackList(id, convertedData, historyId);
        }
      } else {
        resData = await createBlackList(id, convertedData);
      }

      closeModal();

      if (resData?.status === "SUCCESS") {
        setIsSuccessModalOpen(true);
        reset();
      }
    } catch (error) {
      setIsErrorModalOpen(true);
    }
  };

  const createSuccessAction = () => {
    setIsSuccessModalOpen(false);
    navigate(ROUTES.PROCUREMENT.VENDORS);
  };

  const closeErrorModal = () => {
    setIsErrorModalOpen(false);
  };

  return (
    <div>
      {/* modals  */}
      {isSuccessModalOpen && (
        <SuccessModal
          isModalOpen={isSuccessModalOpen}
          action={createSuccessAction}
        />
      )}
      {isErrorModalOpen && (
        <ErrorModal
          isModalOpen={isErrorModalOpen}
          closeModal={closeErrorModal}
        />
      )}
      {/* modals end */}

      <Modal
        isOpen={openModal}
        portal
        overlay={openModal}
        closeAble
        onClose={closeModal}
      >
        <form className="container" onSubmit={handleSubmit(onSubmit)}>
          <div className="p-10 w-100 d-flex flex-column gap-6">
            <div className="d-flex align-items-center gap-6">
              <div>
                <Text weight="semibold" color="title" size="sm">
                  {t("PROCUREMENT_ADD_VENDORS.FORM.FIELDS.FIELD_7.NAME")}
                </Text>
                <span className="text-danger">&#42;</span>
              </div>
              <InputSwitch
                id="isBlackList"
                {...register("isBlackList")}
                onChange={(e: any) => setValue("isBlackList", e.target.checked)}
                controlling
                error={errors as any}
              />
            </div>

            <InputDateControllerVertical
              control={control}
              name="fromDate"
              register={{
                ...register("fromDate", {
                  required: "From date is required",
                }),
              }}
              errors={errors}
              label="PROCUREMENT_ADD_VENDORS.FORM.FIELDS.FIELD_9"
              required
              disabled={historyId ? true : false}
            />

            <InputDateControllerVertical
              control={control}
              name="toDate"
              register={{
                ...register("toDate", {
                  required: "To date is required",
                }),
              }}
              errors={errors}
              label="PROCUREMENT_ADD_VENDORS.FORM.FIELDS.FIELD_10"
              required
            />

            <InputTextAreaVertical
              register={{
                ...register("reason"),
              }}
              label="PROCUREMENT_ADD_VENDORS.FORM.FIELDS.FIELD_11"
              disabled={historyId ? true : false}
            />
            <MultiFileRow
              name="historyDocuments"
              register={register}
              setValue={setValue}
              control={control}
              fileDetails={["documentName", "date", "remarks", "memorialNo"]}
              isVertical={true}
            />
            <div className="text-end col-12">
              <Button fill="outline" type="light" size="sm" htmlType="submit">
                {t("PROCUREMENT_CREATE.SPEC_PREPARATION.FORM.BUTTONS.SAVE")}
              </Button>
            </div>
          </div>
        </form>
      </Modal>
    </div>
  );
}
